import * as React from 'react'
import { ScrollView, View } from 'react-native'
import styled from '@theme/styled-components'

import ItemSelection from '@screens/incident/filters/ItemSelection'
import ModalHeader from '@components/filter/ModalHeader'
import TagSection from '@components/filter/TagSection'
import Button from '@components/button/Button'

import useI18n from '@i18n/useI18n'

interface Props {
  onClose: () => void
  onApplyFilter: (filters: UserFilters) => void
  filters: UserFilters
  onReset: () => void
  filterItems: UserFilterItems
  initialFilters: UserFilters
}

const IncidentFiltersMobile = ({ onClose, onApplyFilter, filters, onReset, filterItems, initialFilters }: Props) => {
  const i18n = useI18n()
  const [screen, setScreen] = React.useState<'MAIN' | UserFiltersName>('MAIN')
  const [localFilters, setLocalFilters] = React.useState<UserFilters>(filters)

  const onBack = () => {
    setScreen('MAIN')
  }

  const resetFilters = () => {
    onReset()
    setLocalFilters(initialFilters)
  }

  const deleteItem = (idx: number, key: keyof UserFilters) => {
    setLocalFilters((prevState) => {
      const filterItem = prevState[key] as FilterItem[]

      const filtered = filterItem.filter((item, index) => index !== idx)
      return { ...prevState, [key]: filtered }
    })
  }

  const updateLocalFilter = (filter: any) => {
    setLocalFilters((prevState) => ({
      ...prevState,
      [filter.name]: filter.value,
    }))
  }

  const applyFilters = () => {
    onApplyFilter(localFilters)
    onClose()
  }

  const keys: UserFiltersName[] = Object.keys(filters) as UserFiltersName[]

  return (
    <MainContainer>
      {screen === 'MAIN' && (
        <>
          <ModalHeader
            left={{ name: 'close', onClick: onClose }}
            title={i18n.t('screens.incidentList.filters.modal.main.title')}
            right={{ label: i18n.t('screens.incidentList.filters.modal.main.reset'), onClick: resetFilters }}
          />
          <ScrollView showsVerticalScrollIndicator={false}>
            {keys.map((key) => (
              <TagSection
                key={key}
                title={i18n.t(`screens.admin.users.filters.${key}`)}
                link={{
                  label: i18n.t(`screens.admin.users.filters.placeholder.${key}`),
                  onClick: () => setScreen(key),
                }}
                items={localFilters[key].map((item) => item.name)}
                onDelete={(idx) => deleteItem(idx, key)}
              />
            ))}
          </ScrollView>
          <Footer>
            <Button
              label={i18n.t('screens.incidentList.filters.modal.button')}
              onClick={applyFilters}
              status="active"
            />
          </Footer>
        </>
      )}
      {screen !== 'MAIN' && (
        <ItemSelection
          title={i18n.t(`screens.admin.users.filters.${screen}`)}
          onBack={onBack}
          items={filterItems[screen]}
          updateFilter={updateLocalFilter}
          filterName={screen}
          placeholder={i18n.t(`screens.admin.users.filters.placeholder.${screen}`)}
          initValues={localFilters[screen]}
        />
      )}
    </MainContainer>
  )
}

const MainContainer = styled(View)`
  flex: 1;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 30px;
`
const Footer = styled(View)`
  padding: 16px;
  background-color: ${(props) => props.theme.colors.background};
`

export default IncidentFiltersMobile
